/* unplugin-vue-components disabled */import script from "./past-flat-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./past-flat-list.vue?vue&type=script&setup=true&lang=ts"

import "./past-flat-list.vue?vue&type=style&index=0&id=0f0f527c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0f527c"]])

export default __exports__